import { render } from "./CartNotification.vue?vue&type=template&id=db1a9898"
import script from "./CartNotification.vue?vue&type=script&lang=js"
export * from "./CartNotification.vue?vue&type=script&lang=js"

import "./CartNotification.vue?vue&type=style&index=0&id=db1a9898&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__